<template>
    <div>
        <div v-if="0" class="d-flex justify-space-between">
            <!-- BACK -->
            <v-btn
                color="grey darken-2 white--text"
                small
                :to="{ name: 'staff' }"
                class="mb-sm-4 mb-md-0"
            >
                <v-icon small class="me-1"> mdi-arrow-left-circle </v-icon>
                Back
            </v-btn>
        </div>
        <v-row :no-gutters="$vuetify.breakpoint.mdAndUp" dense class="ma-0">
            <!-- left side -->
            <v-col md="3" cols="12" class="pe-md-3">
                <v-form @submit.prevent="submit" ref="form" class="form-info">
                    <v-row v-if="$vuetify.breakpoint.mdAndUp" class="ma-0" dense>  
                        <!-- employee photo -->
                        <v-col v-if="configStaffByRole?.Image" md="12" sm="6" cols="12" align-self="center">
                            <div class="d-flex justify-center pb-0">
                                <div class="personal-image">
                                    <v-img
                                        :height="!$vuetify.breakpoint.sm ? 100 : 140"
                                        :max-height="!$vuetify.breakpoint.sm ? 100 : 140"
                                        :width="!$vuetify.breakpoint.sm ? 100 : 140"
                                        :max-width="!$vuetify.breakpoint.sm ? 100 : 140"
                                        class="rounded-circle"
                                        :src="previewPhoto || medicalRepImagePath || require(
                                            medicalRepData.gender === gender.male
                                                ? '@/assets/male.jpg'
                                                : '@/assets/avatar-10-vector-37332908.jpg'
                                        )"
                                        :gradient="medicalRepPhoto ? '#eee2, #eee7, #eee2' : null"
                                    ></v-img>
                                    
                                    <div class="personal-image__actions">
                                        <v-btn
                                            v-if="medicalRepPhoto !== null"
                                            icon
                                            width="30"
                                            height="30"
                                            min-width="0"
                                            color="red lighten-1"
                                            @click="previewPhoto = null; medicalRepPhoto = null"
                                        >
                                            <v-icon> mdi-delete </v-icon>
                                        </v-btn>

                                        <v-file-input
                                            v-model="medicalRepPhoto"
                                            class="ma-0 pa-0"
                                            accept="image/*"
                                            :label="$t('inputs.employee-photo')"
                                            placeholder="Pick a photo"
                                            :prepend-icon="medicalRepPhoto !== null ? 'mdi-image' : 'mdi-plus-circle'"
                                            hide-input
                                            @change="onImageChange"
                                        ></v-file-input>
                                    </div>
                                </div>
                            </div>
                        </v-col>

                        <v-col v-if="staffConfig.EmployeeName" cols="12" sm="6" md="12">
                            <!-- name -->
                            <v-text-field
                                v-model="medicalRepData.name"
                                :label="$t('inputs.employee')"
                                hide-details
                                outlined
                                dense
                                prepend-icon="mdi-account-tie"
                                :disabled="!isEditActive"
                                class="mb-1"
                                :readonly="submitLoading"
                            ></v-text-field>
                            
                            <!-- gender -->
                            <v-radio-group
                                v-if="staffConfig.Gender"
                                v-model="medicalRepData.gender"
                                hide-details
                                row
                                dense
                                class="ma-0 pt-0"
                                :readonly="submitLoading"
                            >
                                <span class="d-flex align-center me-1">
                                    <v-icon class="me-2" size="26"> mdi-gender-male-female</v-icon>
                                    {{$t('inputs.gender')}}:
                                </span>
                                <v-radio
                                    v-for="gender in genders"
                                    :key="gender.id"
                                    :label="gender.name"
                                    :value="gender.id"
                                    dense
                                    hide-details
                                    class="ma-0 me-2"
                                    :disabled="!isEditActive"
                                ></v-radio>
                            </v-radio-group>

                            <!-- birthDate & phone -->
                            <template v-if="$vuetify.breakpoint.smAndDown">
                                <v-text-field
                                    v-if="configStaffByRole?.Certificate"
                                    v-model="medicalRepData.certificate"
                                    :label="$t('inputs.certificate')"
                                    clearable
                                    required
                                    outlined
                                    dense
                                    prepend-icon="mdi-file-certificate "
                                    hide-details="auto"
                                    class="mb-1"
                                    :disabled="!isEditActive"
                                    :readonly="submitLoading"
                                ></v-text-field>
                                
                                <!-- birthDate -->
                                <bee-date-picker
                                    v-if="configStaffByRole?.EmployeeBirthdate"
                                    v-model="medicalRepData.birthDate"
                                    :input-label="$t('inputs.birthday')"
                                    menu-picker
                                    dense
                                    hide-details
                                    :input-props="{
                                        outlined: true,
                                        dense: true,
                                        prependIcon: 'mdi-calendar'
                                    }"
                                    :disabled="!isEditActive"
                                    :readonly="submitLoading"
                                ></bee-date-picker>
                                
                                <!-- phone -->
                                <v-text-field 
                                    v-if="staffConfig.EmployeePhoneNumber"
                                    v-model="medicalRepData.phoneNumber"
                                    :label="$t('inputs.phone-number')"
                                    dense
                                    hide-details
                                    prepend-icon="mdi-phone"
                                    outlined
                                    :disabled="!isEditActive"
                                    class="mt-2"
                                    :readonly="submitLoading"
                                />
                            </template>
                        </v-col>

                        <!-- birthDate & phone -->
                        <template v-if="$vuetify.breakpoint.mdAndUp">
                            <!-- certificate -->
                            <v-col cols="12" sm="6" md="12">
                                <v-text-field
                                    v-if="configStaffByRole?.Certificate"
                                    v-model="medicalRepData.certificate"
                                    :label="$t('inputs.certificate')"
                                    clearable
                                    required
                                    outlined
                                    dense
                                    prepend-icon="mdi-file-certificate "
                                    hide-details="auto"
                                    class="mb-1"
                                    :disabled="!isEditActive"
                                    :readonly="submitLoading"
                                ></v-text-field>
                            </v-col>
                            <!-- birthday -->
                            <v-col cols="12" sm="6" md="12">
                                <bee-date-picker
                                    v-if="configStaffByRole?.EmployeeBirthdate"
                                    v-model="medicalRepData.birthDate"
                                    :input-label="$t('inputs.birthday')"
                                    elevation="2"
                                    menu-picker
                                    dense
                                    hide-details
                                    :input-props="{
                                        outlined: true,
                                        dense: true,
                                        prependIcon: 'mdi-calendar'
                                    }"
                                    :disabled="!isEditActive"
                                    :readonly="submitLoading"
                                ></bee-date-picker>
                            </v-col>
                            
                            <!-- phone -->
                            <v-col cols="12" sm="6" md="12">
                                <v-text-field 
                                    v-if="staffConfig.EmployeePhoneNumber"
                                    v-model="medicalRepData.phoneNumber"
                                    :label="$t('inputs.phone-number')"
                                    dense
                                    hide-details
                                    outlined
                                    prepend-icon="mdi-phone"
                                    :disabled="!isEditActive"
                                    :readonly="submitLoading"
                                />
                            </v-col>
                        </template>

                        <!-- Telephone number -->
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field
                                v-if="configStaffByRole?.EmployeeLandLine"
                                v-model="medicalRepData.landlineNumber"
                                :label="$t('inputs.phone-number')"
                                outlined
                                dense
                                prepend-icon="mdi-phone-classic"
                                hide-details="auto"
                                :disabled="!isEditActive"
                                :readonly="submitLoading"
                            ></v-text-field>
                        </v-col>
        
                        <!-- address -->
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field 
                                v-if="staffConfig.EmployeeAddress"
                                v-model="medicalRepData.address"
                                :label="$t('inputs.full-address')"
                                dense
                                hide-details
                                outlined
                                prepend-icon="mdi-map-marker"
                                :disabled="!isEditActive"
                                :readonly="submitLoading"
                            />
                        </v-col>
                        
                        <!-- email -->
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field 
                                v-if="staffConfig.EmployeeEmail"
                                v-model="medicalRepData.email"
                                :label="$t('inputs.email')"
                                dense
                                hide-details
                                outlined
                                prepend-icon="mdi-email"
                                :disabled="!isEditActive"
                                :readonly="submitLoading"
                            />
                        </v-col>   
                
                        <!-- facebookProfileUrl -->
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field 
                                v-if="configStaffByRole?.EmployeeFacebook"
                                v-model="medicalRepData.facebookProfileUrl"
                                :label="$t('facebook-profile-url')"
                                dense
                                hide-details
                                outlined
                                prepend-icon="mdi-facebook"
                                :disabled="!isEditActive"
                                :readonly="submitLoading"
                            />
                        </v-col>  
                
                        <!-- startingDate -->
                        <v-col v-if="staffConfig.HiringDate" cols="12" sm="6" md="12">
                            <bee-date-picker
                                v-model="medicalRepData.startingDate"
                                :input-label="$t('inputs.hiring-date')"
                                elevation="2"
                                menu-picker
                                dense
                                hide-details
                                :input-props="{
                                    outlined: true,
                                    dense: true,
                                    prependIcon: 'mdi-calendar'
                                }"
                                :disabled="!isEditActive"
                                :readonly="submitLoading"
                                :allowed-dates="disableDates"
                            ></bee-date-picker>
                        </v-col>

                        <!-- username -->
                        <v-col v-if="staffConfig.Username" cols="12" sm="6" md="12">
                            <v-text-field
                                v-model="medicalRepData.username"
                                :label="$t('inputs.username')"
                                elevation="2"
                                dense
                                hide-details
                                outlined
                                prepend-icon="mdi-account"
                                :disabled="!isEditActive"
                                :readonly="submitLoading"
                            />
                        </v-col>

                        <!-- password -->
                        <v-col v-if="staffConfig.Password" cols="12" sm="6" md="12">
                            <v-text-field
                                v-model="medicalRepData.password"
                                :label="$t('inputs.password')"
                                elevation="2"
                                dense
                                hide-details
                                outlined
                                prepend-icon="mdi-eye"
                                :disabled="!isEditActive"
                                :readonly="submitLoading"
                            />
                        </v-col>

                        <!-- action -->
                        <v-col cols="12" class="pa-md-0">
                            <v-btn
                                v-if="isSuperAdmin || permissionsUser.MedicalReps"
                                :color="!isEditActive ? 'edit-color white--text' : 'success white--text'"
                                :loading="submitLoading"
                                type="submit"
                                height="35"
                                :width="!isEditActive ? '100%' : '70%'"
                            >
                                <v-icon size="22" class="me-1" >
                                    {{ !isEditActive ? 'mdi-pencil' : 'mdi-content-save-edit'}} 
                                </v-icon>
                                {{ !isEditActive ? $t('edit') : $t('save')}}
                            </v-btn>
                            <v-btn
                            	v-if="isEditActive"
                                height="35"
                                width="27%"
                                class="ms-2"
                            	@click="isEditActive = false"
                            >
                                {{ $t('cancel') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-else class="ma-0" dense>  
                        <!-- employee photo -->
                        <v-col v-if="configStaffByRole?.Image" md="12" sm="6" cols="12" align-self="center">
                            <div class="d-flex justify-center pb-0">
                                <div class="personal-image">
                                    <v-img
                                        :height="!$vuetify.breakpoint.sm ? 100 : 140"
                                        :max-height="!$vuetify.breakpoint.sm ? 100 : 140"
                                        :width="!$vuetify.breakpoint.sm ? 100 : 140"
                                        :max-width="!$vuetify.breakpoint.sm ? 100 : 140"
                                        class="rounded-circle"
                                        :src="previewPhoto || medicalRepImagePath || require(
                                            medicalRepData.gender === gender.male
                                                ? '@/assets/male.jpg'
                                                : '@/assets/avatar-10-vector-37332908.jpg'
                                        )"
                                        :gradient="medicalRepPhoto ? '#eee2, #eee7, #eee2' : null"
                                    ></v-img>
                                    
                                    <div class="personal-image__actions">
                                        <v-btn
                                            v-if="medicalRepPhoto"
                                            icon
                                            width="30"
                                            height="30"
                                            min-width="0"
                                            color="red lighten-1"
                                            @click="previewPhoto = null; medicalRepPhoto = null"
                                        >
                                            <v-icon> mdi-delete </v-icon>
                                        </v-btn>

                                        <v-file-input
                                            v-model="medicalRepPhoto"
                                            class="ma-0 pa-0"
                                            accept="image/*"
                                            label="employee photo"
                                            placeholder="Pick a photo"
                                            :prepend-icon="medicalRepPhoto ? 'mdi-image' : 'mdi-plus-circle'"
                                            hide-input
                                            @change="onImageChange"
                                        ></v-file-input>
                                    </div>
                                </div>
                            </div>

                            <!-- name -->
                            <v-text-field
                                v-if="staffConfig.EmployeeName"
                                v-model="medicalRepData.name"
                                :label="$t('inputs.employee')"
                                hide-details
                                outlined
                                dense
                                prepend-icon="mdi-account-tie"
                                :disabled="!isEditActive"
                                class="mb-1"
                                :readonly="submitLoading"
                            ></v-text-field>

                            <!-- gender -->
                            <v-radio-group
                                v-if="staffConfig.Gender"
                                v-model="medicalRepData.gender"
                                hide-details
                                row
                                dense
                                class="ma-0 pt-0"
                                :readonly="submitLoading"
                            >
                                <span class="d-flex align-center me-1">
                                    <v-icon class="me-2" size="26"> mdi-gender-male-female</v-icon>
                                    {{$t('inputs.gender')}}:
                                </span>
                                <v-radio
                                    v-for="gender in genders"
                                    :key="gender.id"
                                    :label="gender.name"
                                    :value="gender.id"
                                    dense
                                    hide-details
                                    class="ma-0 me-2"
                                    :disabled="!isEditActive"
                                    :readonly="submitLoading"
                                ></v-radio>
                            </v-radio-group>
                            
							<!-- birthDate & phone -->
							<template>
                                <!-- Certificate -->
                                <v-text-field
                                    v-if="configStaffByRole?.Certificate"
                                    v-model="medicalRepData.certificate"
                                    :label="$t('inputs.certificate')"
                                    clearable
                                    required
                                    outlined
                                    dense
                                    prepend-icon="mdi-file-certificate "
                                    hide-details="auto"
                                    class="mb-1"
                                    :disabled="!isEditActive"
                                    :readonly="submitLoading"
                                ></v-text-field>

								<!-- birthDate -->
								<bee-date-picker
                                    v-if="configStaffByRole?.EmployeeBirthdate"
									v-model="medicalRepData.birthDate"
									:input-label="$t('inputs.birthday')"
									menu-picker
									dense
									hide-details
									:input-props="{
										outlined: true,
										dense: true,
										prependIcon: 'mdi-calendar'
									}"
									:disabled="!isEditActive"
                                    :readonly="submitLoading"
								></bee-date-picker>
                                
                                <!-- phone -->
                                <v-text-field 
                                    v-if="staffConfig.EmployeePhoneNumber"
                                    v-model="medicalRepData.phoneNumber"
                                    :label="$t('inputs.phone-number')"
                                    dense
                                    hide-details
                                    prepend-icon="mdi-phone"
                                    outlined
                                    :disabled="!isEditActive"
                                    class="mt-2"
                                    :readonly="submitLoading"
                                />
                            </template>

                            <!-- Telephone number -->
                            <v-text-field
                                v-if="configStaffByRole?.EmployeeLandLine"
                                v-model="medicalRepData.landlineNumber"
                                :label="$t('inputs.phone-number')"
                                outlined
                                dense
                                prepend-icon="mdi-phone-classic"
                                hide-details="auto"
                                :disabled="!isEditActive"
                                class="mt-2"
                                :readonly="submitLoading"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <!-- address -->
                            <v-text-field 
                                v-if="staffConfig.EmployeeAddress"
                                v-model="medicalRepData.address"
                                :label="$t('inputs.full-address')"
                                dense
                                hide-details
                                outlined
                                prepend-icon="mdi-map-marker"
                                :disabled="!isEditActive"
                                class="mt-2"
                                :readonly="submitLoading"
                            />
                            <!-- email -->
                            <v-text-field 
                                v-if="staffConfig.EmployeeEmail"
                                v-model="medicalRepData.email"
                                :label="$t('inputs.email')"
                                dense
                                hide-details
                                outlined
                                prepend-icon="mdi-email"
                                :disabled="!isEditActive"
                                class="mt-2"
                                :readonly="submitLoading"
                            />

                            <!-- facebookProfileUrl -->
                            <v-text-field 
                                v-if="configStaffByRole?.EmployeeFacebook"
                                v-model="medicalRepData.facebookProfileUrl"
                                :label="$t('facebook-profile-url')"
                                dense
                                hide-details
                                outlined
                                prepend-icon="mdi-facebook"
                                :disabled="!isEditActive"
                                class="my-2"
                            />

                            <bee-date-picker
                                v-if="staffConfig.HiringDate"
                                v-model="medicalRepData.startingDate"
                                :input-label="$t('inputs.hiring-date')"
                                elevation="2"
                                menu-picker
                                dense
                                hide-details
                                :input-props="{
                                    outlined: true,
                                    dense: true,
                                    prependIcon: 'mdi-calendar'
                                }"
                                :disabled="!isEditActive"
                                class="mt-2"
                                :readonly="submitLoading"
                                :allowed-dates="disableDates"
                            ></bee-date-picker>
                            <v-text-field
                                v-if="staffConfig.Username"
                                v-model="medicalRepData.username"
                                :label="$t('inputs.username')"
                                elevation="2"
                                dense
                                hide-details
                                outlined
                                prepend-icon="mdi-account"
                                :disabled="!isEditActive"
                                class="mt-2"
                                :readonly="submitLoading"
                            />

                            <v-text-field
                                v-if="staffConfig.Password"
                                v-model="medicalRepData.password"
                                :label="$t('inputs.password')"
                                elevation="2"
                                dense
                                hide-details
                                outlined
                                prepend-icon="mdi-eye"
                                :disabled="!isEditActive"
                                class="mt-2"
                                :readonly="submitLoading"
                            />
                        </v-col>
                        <!-- action -->
                        <v-col cols="12" class="pa-md-0">
                            <v-btn
                                v-if="isSuperAdmin || permissionsUser.MedicalReps"
                                :color="!isEditActive ? 'edit-color white--text' : 'success white--text'"
                                :loading="submitLoading"
                                type="submit"
                                height="35"
                                :width="!isEditActive ? '100%' : '70%'"
                            >
                                <v-icon size="22" class="me-1" >
                                    {{ !isEditActive ? 'mdi-pencil' : 'mdi-content-save-edit'}} 
                                </v-icon>
                                {{ !isEditActive ? $t('edit') : $t('save') }}
                            </v-btn>
                            <v-btn
                            	v-if="isEditActive"
                                height="35"
                                width="27%"
                                class="ms-2"
                            	@click="isEditActive = false"
                            >
                                {{ $t('cancel') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>

            <v-divider
            	v-if="$vuetify.breakpoint.mdAndUp"
            	vertical
            	:style="{ minHeight: `${$vuetify.breakpoint.height - 60}px` }"
            />
            <!-- tabs -->
            <v-col md="9" cols="12" class="ps-md-3">
                <div class="d-flex justify-space-between">
                    <div>
                        <div class="d-flex justify-space-between">
                            <div>
                                <!-- tabs -->
                                <v-tabs v-model="tab" show-arrows height="35">
                                    <!-- :to="{ 
                                            name: 'medical-rep-personal-data', 
                                            params: { id: $route.params.id },
                                            query: { employeeType: userType.medicalRep }
                                        }" -->
                                        
                                    <v-tab
                                        class="text-capitalize "
                                        :to="{
                                            name: 'medical-rep-info',
                                            params: { id: $route.params.id },
                                            query: { 
                                                employeeType: userType.medicalRep,
                                                preview: $route.query.preview,
                                                role:  $route.query.tabRole
                                            }
                                        }"
                                    >
                                        {{$t('work-data')}}
                                    </v-tab>
                                    <v-tab
                                        v-if="!firstLevel"
                                        class="text-capitalize "
                                        :to="{ 
                                            name: 'medical-rep-info-day-requests', 
                                            params: { id: $route.params.id },
                                            query: { 
                                                employeeType: userType.medicalRep,
                                                preview: $route.query.preview,
                                                role:  $route.query.tabRole
                                            }
                                        }"
                                    >
                                        {{$t('day-off-requests')}}
                                    </v-tab>
                                    <v-tab
                                        class="text-capitalize "
                                        :to="{ 
                                            name: 'medical-samples', 
                                            params: { id: $route.params.id },
                                            query: { 
                                                employeeType: userType.medicalRep,
                                                preview: $route.query.preview,
                                                role:  $route.query.tabRole
                                            }
                                        }"
                                    >
                                        {{$t('samples')}}
                                    </v-tab>

                                    <v-tab
                                        v-if="(isSuperAdmin || permissionsUser.MedicalReps) && !firstLevel"
                                        class="text-capitalize "
                                        :to="{ 
                                            name: 'medical-rates', 
                                            params: { id : $route.params.id }, 
                                            query: { 
                                                employeeType: userType.medicalRep,
                                                preview: $route.query.preview,
                                                role:  $route.query.tabRole
                                            }
                                        }"
                                    >
                                        {{$t('rates')}}
                                    </v-tab>
                                    <v-tabs-slider color="primary"></v-tabs-slider>
                                </v-tabs>
                                <v-divider class="mb-2"/>
                            </div>
                        <!-- BACK -->
                        <v-btn
                            color="grey darken-2 white--text"
                            small
                            :to="{ 
                                name: 'staff', 
                                query: {
                                    role: $route.query.role
                                } 
                            }"
                            class="mb-sm-4 mb-md-0 align-self-center"
                        >
                            <v-icon small class="me-1"> mdi-arrow-left-circle </v-icon>
                            {{$t('back')}}
                        </v-btn>
                        </div>
               
                        <div v-if="$route.name === 'medical-rep-info' ">
                            <!-- work data -->
                            <v-row  dense class="ma-0">
                                <!-- city -->
                                <v-col v-if="staffConfig.City" lg="3" md="4" sm="6" cols="12" align-self="center">
                                    <v-autocomplete
                                        v-model="medicalRepData.cityId"
                                        :items="cities"
                                        item-text="name"
                                        item-value="id"
                                        :label="$t('inputs.city')"
                                        dense
                                        :disabled="loading || !isEditActive"
                                        prepend-icon="mdi-map-marker-multiple"
                                        persistent-hint
                                        outlined
                                        multiple
                                        clearable
                                        @change="getRegion()"
                                        :search-input.sync="searchCityId"
                                        hide-details
                                        :readonly="submitLoading"
                                    >
                                        <!-- @change="getSector()" -->
                                        <template v-slot:selection="{ item, index }">
                                            <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                                (+{{ medicalRepData.cityId.length - 1 }})
                                            </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item ripple @click="toggleCities">
                                                <v-list-item-action>
                                                    <v-icon color='indigo darken-4'>{{ iconCities }}</v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{$t('select-all')}}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider />
                                        </template>
                                    </v-autocomplete>
                                </v-col>

                                <!-- regions -->
                                <v-col v-if="staffConfig.Region" lg="4" md="4" sm="6" cols="12" align-self="center">
                                    <v-autocomplete
                                        v-model="medicalRepData.regionIds"
                                        :items="medicalRepData.cityId.length !== 0 ? regionsAll.filter(c => medicalRepData.cityId.includes(c.cityId)) : []"
                                        item-text="name"
                                        item-value="id"
                                        dense
                                        hide-details
                                        outlined
                                        :label="managementHierarchyRegions ? $t('inputs.areas') : $t('inputs.region')"
                                        prepend-icon="mdi-medical-bag"
                                        multiple
                                        :disabled="!isEditActive"
                                        clearable
                                        :search-input.sync="searchRegionId"
                                        @change="searchRegionId = null"
                                        :readonly="submitLoading"
                                    > 
                                        <template v-slot:selection="{ item, index }">
                                            <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                                (+{{ medicalRepData.regionIds.length - 1 }})
                                            </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item ripple @click="toggleRegion">
                                                <v-list-item-action>
                                                    <v-icon color='indigo darken-4'>{{ iconRegions }}</v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{$t('select-all')}}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider />
                                        </template>

                                    </v-autocomplete>
                                </v-col>

                                <!-- teams -->
                                <v-col v-if="staffConfig.EmployeeTeam" lg="3" md="4" sm="6" cols="12" align-self="center">
                                    <v-autocomplete
                                        v-model="medicalRepData.teamId"
                                        :items="teams"
                                        item-text="name"
                                        item-value="id"
                                        :label="$t('inputs.teams')"
                                        dense
                                        hide-details
                                        outlined
                                        multiple
                                        clearable
                                        :disabled="!isEditActive"
                                        :loading="loading"
                                        :search-input.sync="searchTeamId"
                                        @change="searchTeamId = null; medicalRepData.specialtyIds = []"
                                        :readonly="submitLoading"
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                                (+{{ medicalRepData.teamId.length - 1 }})
                                            </span>
                                        </template>

                                        <!-- <template v-slot:prepend-item>
                                            <v-list-item ripple @click="toggleTeam">
                                                <v-list-item-action>
                                                    <v-icon color='indigo darken-4'>{{ iconTeam }}</v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{$t('select-all')}}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider />
                                        </template> -->
                                    </v-autocomplete>
                                </v-col>

                                <!-- lineManager -->
                                <v-col lg="3" md="4" sm="6" cols="12" align-self="center">
                                    <v-autocomplete
                                        v-model="medicalRepData.lineManagerId"
                                        :items="lineManager.filter(c => c.id !== $route.params.id)"
                                        item-text="name"
                                        item-value="id"
                                        :label="$t('inputs.line-manager')"
                                        dense
                                        hide-details
                                        outlined
                                        prepend-icon="mdi-account-tie"
                                        :disabled="!isEditActive || lineManagerLoading"
                                        :loading="loading || lineManagerLoading"
                                        :readonly="submitLoading"
                                    />
                                </v-col>
 
                                <v-col v-if="(medicalRepData.teamId.length === 0 || separatingSpecialtiesFromTeams) || staffConfig.EmployeeSpeciality" align-self="center" lg="3" md="4" sm="6" cols="12">
                                    <v-autocomplete
                                        v-model="medicalRepData.specialtyIds"
                                        :items="specialties"
                                        item-text="name"
                                        item-value="id"
                                        dense
                                        hide-details
                                        outlined
                                        :label="$t('inputs.specialties')"
                                        prepend-icon="mdi-medical-bag"
                                        multiple
                                        :disabled="(!isEditActive || medicalRepData.teamId.length !== 0) && !separatingSpecialtiesFromTeams "
                                        :search-input.sync="searchSpecialties"
                                        @change="searchSpecialties = null"
                                        :readonly="submitLoading"
                                    > 

                                        <template v-slot:selection="{ item, index }">
                                            <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                                (+{{ medicalRepData.specialtyIds.length - 1 }})
                                            </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item ripple @click="toggle">
                                                <v-list-item-action>
                                                    <v-icon color='indigo darken-4'>{{ icon }}</v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{$t('select-all')}}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider />
                                        </template>

                                    </v-autocomplete>
                                </v-col>
                
                                <v-col v-if="staffConfig.Role" align-self="center" lg="3" md="4" sm="6" cols="12">
                                    <v-autocomplete
                                        v-model="medicalRepData.roleId"
                                        :items="roles"
                                        item-text="name"
                                        item-value="id"
                                        dense
                                        hide-details
                                        outlined
                                        :label="$t('inputs.role')"
                                        prepend-icon="mdi-medical-bag"
                                        :disabled="!isEditActive"
                                        @change="!(
                                            roles.find(c => c.id === medicalRepData.roleId).name.includes('Rep') || 
                                            roles.find(c => c.id === medicalRepData.roleId).name.includes('REP') || 
                                            roles.find(c => c.id === medicalRepData.roleId).name.includes('rep')) ? 
                                            showEmployee = true : 
                                            showEmployee = false;
                                            getDirectEmployee()
                                        "
                                        :readonly="submitLoading"
                                    />
                                </v-col>
            
                                <!-- show -->
                                <v-col v-if="medicalRepData.userType !== userType.medicalRep" class="px-0 d-flex justify-center" align-self="center">
                                    <v-btn
                                        small
                                        color="green darken-1 white--text"
                                        @click="showEmployee = !showEmployee"
                                        :disabled="loadingDirect || !isEditActive || submitLoading"
                                    >
                                        <v-icon v-if="$i18n.locale === 'en'" small class="me-2">mdi-eye</v-icon>
                                        {{ $t('show-your-employees') }}
                                        <v-icon v-if="$i18n.locale === 'ar'" small class="ms-2">mdi-eye</v-icon>
                                    </v-btn>
                                </v-col>
                                <!-- target -->
                                <v-col
                                    v-if="configStaffByRole?.VisitTarget"
                                    align-self="center"
                                    lg="3"
                                    md="4"
                                    sm="6"
                                    cols="12"
                                >
                                    <v-text-field
                                        v-model.number="medicalRepData.targetValue"
                                        :label="$t('inputs.target')"
                                        type="number"
                                        :rules="rules.number"
                                        required
                                        outlined
                                        dense
                                        hide-details="auto"
                                        :loading="loading"
                                        prepend-icon="mdi-target-account"
                                        :disabled="!isEditActive"
                                        :readonly="submitLoading"
                                    ></v-text-field>
                                </v-col>

                                <v-col
                                    v-if="configStaffByRole?.FinancialTarget"
                                    align-self="center"
                                    lg="3"
                                    md="4"
                                    sm="6"
                                    cols="12"
                                >
                                    <v-text-field
                                        v-model.number="medicalRepData.financialTargetValue"
                                        :label="$t('inputs.financial-target-value')"
                                        type="number"
                                        :rules="rules.number"
                                        required
                                        outlined
                                        dense
                                        hide-details="auto"
                                        :loading="loading"
                                        prepend-icon="mdi-target-account"
                                        :disabled="!isEditActive"
                                        :readonly="submitLoading"
                                    ></v-text-field>
                                </v-col>

                                <!-- leaveDaysNumber -->
                                <v-col
                                    v-if="(isSuperAdmin || permissionsUser.ManageLeaveBalances !== roleName.nothing) && staffConfig.VacationDays"
                                    lg="3"
                                    md="4"
                                    sm="6"
                                    cols="12"
                                    align-self="center"
                                >   
                                    <v-text-field
                                        v-model.number="medicalRepData.leaveDaysNumber"
                                        :label="$t('inputs.leave-days-number')"
                                        type="number"
                                        :rules="rules.number"
                                        required
                                        outlined
                                        dense
                                        hide-details="auto"
                                        :loading="loading"
                                        prepend-icon="mdi-calendar"
                                        :disabled="!isEditActive"
                                        :readonly="submitLoading"
                                    ></v-text-field>
                                        <!-- :readonly="!isAdmin || (permissionsUser.ManageLeaveBalances === roleName.read)" -->
                                </v-col>

                                <!-- submit button -->
                                <v-col
                                    v-if="(isSuperAdmin || permissionsUser.MedicalReps === roleName.action) && !showEmployee"
                                    align-self="center"
                                    cols="12"
                                    class="text-end"
                                    @click="isEditActive = true"
                                >
                                    <v-btn
                                        v-if="isSuperAdmin || employeeId !== $route.params.id"
                                        height="30"
                                        :color="!isEditActive ? 'edit-color white--text' : 'success white--text' "
                                        @click="submit"
                                        class="px-md-4"
                                        :class="{ 'mb-1': $vuetify.breakpoint.smAndDown }"
                                        :loading="submitLoading"
                                    >
                                        <v-icon size="22" class="me-1"> 
                                            {{ !isEditActive ? 'mdi-pencil' : 'mdi-content-save' }} 
                                        </v-icon>
                                        {{ !isEditActive ? $t('edit') : $t('save') }}
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <!-- employee direct -->
                            <v-card v-if="showEmployee"
                                class="scroll-style mb-4"
                            >
                                <v-card-title class="fs-1rem">
                                    <span>
                                        {{ $t('Staff.choose-the-employees-who-will-be-their-supervisor') }}
                                    </span>
                                </v-card-title>
                                
                                <v-card-text >
                                    <div v-if="directBriefEmployee.length !== 0" class="d-flex flex-wrap">
                                        <div
                                            v-for="(r, index) in directBriefEmployee"
                                            :key="index"
                                            class="mx-2 "
                                            style="width: 200px"
                                        >
                                            <!-- {{r.model}} -->
                                            <v-checkbox
                                                v-model="r.model"
                                                :value="r.lineManager === $route.params.id ? r.id : r.id"
                                                color="primary"
                                                :label="r.name"
                                                dense
                                                hide-details
                                            />
                                        </div>
                                    </div>
                                    <div v-else class="text-center">
                                        <v-icon> mdi-data </v-icon>                        
                                        <span> {{$t('not-found-data')}} </span>
                                    </div>
                                </v-card-text>

                                <!-- <v-card-actions>
                                    <v-spacer />
                                    <v-btn @click="updateLineManager()" color="success white--text" small :loading="loading">
                                        save
                                    </v-btn>
                                </v-card-actions> -->
                            </v-card>
                            <v-col v-if="(isSuperAdmin || permissionsUser.MedicalReps === roleName.action) && showEmployee" cols="12" class="text-end">
                                <v-btn
                                    v-if="isSuperAdmin || employeeId !== $route.params.id"
                                    height="30"
                                    :color="Boolean($route.query.preview) ? 'edit-color white--text' : 'success white--text' "
                                    @click="updateEmployeeWithYourTeam()"
                                    class="px-md-4"
                                    :class="{ 'mb-1': $vuetify.breakpoint.smAndDown }"
                                    :loading="submitLoading"
                                >
                                    <v-icon size="22" class="me-1"> 
                                        {{ Boolean($route.query.preview) ? 'mdi-pencil' : 'mdi-content-save' }} 
                                    </v-icon>
                                    {{ Boolean($route.query.preview) ? 'Edit' : 'save'}}
                                </v-btn>
                            </v-col>
                        </div>
					
                    </div>
                    <v-spacer />
                </div>
                <!-- child page -->
                <loader v-if="loading"/>
                <router-view v-else/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { gender, genders, userType, roleName } from '@/helpers/enums'
import rules from '@/validation rules'
import moment from 'moment'
import Loader from '@/components/Loader.vue'
import { firstLevel, extraField, managementHierarchyRegions, separatingSpecialtiesFromTeams, financialTargetValue, isDisabledFriday } from '@/configs/global.config'
import { disableDates } from '@/helpers/functions'

export default {
    name: 'MedicalRepInfo',
    
    components: {
        Loader
    },

    data() {
        return {
            // helpers
            rules,
            gender,
            genders,
            previewPhoto: null,
            userType,
            roleName,

            // data
            medicalRepData: {
                name: null,
                birthDate: null, 
                landlineNumber: null,
                phoneNumber: null,
                cityId: [],
                sectorId: null,
                address: null,
                visitPerDay: null,
                email: null,
                jobPosition: null,
                facebookProfileUrl: null, 
                startingDate: null,
                username: null,
                password: null,
                userType: userType.medicalRep,
                gender: gender.male,
                targetValue: 1,
                lineManagerId: null,
                regionIds: [],
                specialtyIds: [],
                roleId: null,
                teamId: [],
                certificate: null,
                leaveDaysNumber: 0,
                financialTargetValue: 1
            },
            medicalRepImagePath: null,
            medicalRepPhoto: null,
            tab: 0,
            loading: false,
            isEditActive: false,
            submitLoading: false,
            firstLevel, 
            extraField,
			searchCityId: null,
			searchRegionId: null,
			searchTeamId: null,
			lineManager: [],
			searchSpecialties: null,
			loadingDirect: false,
            showEmployee: null,
            directBriefEmployee: [],
			managementHierarchyRegions, 
			separatingSpecialtiesFromTeams,
            financialTargetValue,
            isDisabledFriday,
            disableDates,
            myData: [],
            lineManagerLoading: false,
            configStaffByRole: {}
        }
    },

    watch: {
        'medicalRepData.roleId'(val) {
            if (val) {
                this.configStaffByRole = this.roleEmployeeConfig.find(c => c.key === val)?.data
                return this.configStaffByRole
            }
        },
        immediate: true
    },

    computed: {
        ...mapState({
            medicalReps: state => state.medicalreps.medicalreps,  
            cities: state => state.cities.cities,
            sectorsFiltered: state => state.sectors.sectorsFiltered,
            sectors: state => state.sectors.sectors,
            permissionsUser: state => state.auth.youPermissions,
            isSuperAdmin: state => state.auth.isSuperAdmin,
            teams: state => state.teams.teams,
			specialties: state => state.specialties.specialties,
			roles: state => state.rolePermission.roles,
            regionsAll: state => state.regions.regionsAll,
            employeeId: state => state.auth.self.employeeId,
            staffConfig: state => state.configuration.configurations.staffConfig,
            // config for staff 
            roleEmployeeConfig: state => state.configuration.roleEmployee
        }),

        ...mapGetters({
            getRegionAllById: 'regions/getRegionAllById',
            getTeamById: 'teams/getTeamById'
        }),

		selectedAllCities () {
            return this.medicalRepData.cityId?.length === this.cities?.length;
        },

		iconCities() {
            if (this.selectedAllCities) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },

		iconRegions() {
            if (this.selectedAllRegions) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },

		selectedAllRegions () {
            return this.medicalRepData.regionIds?.length === this.regionsAll.filter(c => this.medicalRepData.cityId?.includes(c.cityId)).length;
        },

		icon() {
            if (this.selectedAllSpecialties) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },
        selectedAllSpecialties () {
            return this.medicalRepData.specialtyIds?.length === this.specialties.length;
        },
    },

    methods: {
        updateEmployeeWithYourTeam() {
            this.submit().then(() => {
                this.updateLineManager()
            })
        },
        getRegion () {
            this.medicalRepData.regionIds = []
            this.medicalRepData.regionIds = this.regionsAll.filter(c => this.medicalRepData.cityId.includes(c.cityId)).map(c => c.id); this.searchCityId = null
        },
		toggleRegion() {
            this.$nextTick(() => {
                if (this.selectedAllRegions) {
                    this.medicalRepData.regionIds = []
                } 
                else {
                    this.medicalRepData.regionIds = []
                    this.medicalRepData.regionIds = this.regionsAll.filter(c => this.medicalRepData.cityId.includes(c.cityId)).map(c => c.id);
                }
            })
        },
		toggleCities () { 
            this.medicalRepData.regionIds = []
            this.$nextTick(() => {
                if (this.selectedAllCities) {
                    this.medicalRepData.cityId = []
                    this.medicalRepData.regionIds = []
                } 
                else {
                    this.medicalRepData.cityId = this.cities.map(c => c.id);
                }
            })
        },
		toggle () {
            this.$nextTick(() => {
                if (this.selectedAllSpecialties) {
                    this.medicalRepData.specialtyIds = []
                } 
                else {
                    this.medicalRepData.specialtyIds = this.specialties.map(c => c.id);
                    this.medicalRepData.specialtyIds.forEach(specialty => {
                    if (this.medicalRepData.specialtyIds.includes(specialty.id)) {
                        this.medicalRepData.specialtyIds.push(specialty.id);
                    }
                });  
                }
            })
        },

        updateLineManager () {
            this.loading = true
            this.$store.dispatch('medicalreps/updateLineManager', { 
                newLineManagerId: this.$route.params.id, 
                employees: this.directBriefEmployee.map(c => c.model).filter(c => c !== null)
            }).finally(() => {
                this.loading = false
                this.showEmployee = false
            })
        },

		getDirectEmployee() {
            this.loadingDirect = true
            this.showEmployee = false
            this.$store.dispatch('medicalreps/fetchEmployeeDirectBrief', {
                employeeId: this.$route.params.id,
                roleId: this.medicalRepData.roleId
            }).then((data) => {
                this.directBriefEmployee = data.map(c => ({ ...c, model: null }))
                this.showEmployee = true
            }).finally(() => {
                this.loadingDirect = false
            })
        },

        submit() {
            if (!this.isEditActive) {
                this.isEditActive = true;
            } else if (this.$refs.form.validate()) {
                if (this.$refs.form.validate()) {
                    this.submitLoading = true;
                    this.isEditActive = true;
                    // check if region change or not
                    // this.myData.regionIds === 
                    const areEqualIgnoreCase = (arr1, arr2) => {
                        const lowerArr1 = arr1.map(id => id.toLowerCase())
                        const lowerArr2 = arr2.map(id => id.toLowerCase())
                        return lowerArr1.length === lowerArr2.length && lowerArr1.every(id => lowerArr2.includes(id));
                    };

                    return Promise.all([
                        this.$store.dispatch('medicalreps/update', {
                            id: this.$route.params.id,
                            data: { 
                                ...this.medicalRepData,
                                specialtyIds: this.medicalRepData.teamId.length !== 0 && !separatingSpecialtiesFromTeams
                                ? this.medicalRepData.teamId.map(c => this.getTeamById(c).specialtyIds).toString().split(',').filter(c => c !== '') 
                                : this.medicalRepData.specialtyIds
                            }
                        }),
                        this.medicalRepData.targetValue !== 1 && this.medicalRepData.userType === userType.medicalRep
                        ? this.$store.dispatch('medicalrepTarget/update', {
                            id: this.$route.params.id,
                            value: this.medicalRepData.targetValue
                        }) : null,

                        (financialTargetValue) 
                        ? this.$store.dispatch('medicalrepTarget/updateTargetFinancialRep', { 
                            id: this.$route.params.id, 
                            value:  this.medicalRepData.financialTargetValue
                        }) : null,
                    ]).then(() => {
                        if (!areEqualIgnoreCase(this.myData.regionIds, this.medicalRepData.regionIds)) {
                            this.getLineManager() 
                        }
                        // const employeeType =
                        //     this.$route.query.employeeType === 'medicalRep' ? 'Medical rep' : 'Adminstrative';
                        this.$eventBus.$emit('show-snackbar', 'Employee is edited', 'this.info');

                        this.$store.dispatch('leaveManagement/fetchCount', { 
                            employeeId: this.$route.params.id 
                        }).then((data) => {
                            this.medicalRepData.leaveDaysNumber = data.daysCount
                        })
                        this.isEditActive = false;
                    }).finally(() => {
                        this.submitLoading = false;
                        this.$router.replace({
                            name: this.$route.params.name,
                            params: {
                                id: this.$route.params.id
                            },
                            query: {
                                // employeeType: this.$route.query.employeeType,
                                preview: true
                            }
                        })
                    })
                }
            }
        },

        onImageChange() {
            if (this.medicalRepPhoto) {
                const reader = new FileReader();
                reader.readAsDataURL(this.medicalRepPhoto);
                reader.onload = e => { this.previewPhoto = e.target.result; }
            }
        },

        getLineManager () {
            this.lineManagerLoading = true
            this.$store.dispatch('medicalreps/fetchEmployeeLineManager', {
				EmployeeId: this.$route.params.id
			}).then((data) => { this.lineManager = data; }).finally(() => {
                this.lineManagerLoading = false
            })
        }
    },

    created() {
        this.loading = true
		Promise.all([
			this.$store.dispatch('medicalreps/fetchEmployeeLineManager', {
				EmployeeId: this.$route.params.id
			}),
            this.$store.dispatch('medicalreps/fetchEmployeeDirectBrief', {
                employeeId: this.$route.params.id
            }),
            
            !this.specialties.length ? this.$requestStack.setRequest({
                key: 'specialties/fetchAll',
                promise: this.$store.dispatch('specialties/fetchAll'),
            }) : this.$requestStack.getRequest('specialties/fetchAll').promise,

            !this.cities.length ? this.$store.dispatch('cities/fetchCityMine', {}) : null,

            !this.regionsAll.length ? this.$store.dispatch('regions/fetchAllRegions', { cities: this.cities }) : null,
            
            !this.teams.length ? this.$store.dispatch('teams/fetchAll') : null,
            this.permissionsUser.Roles !== roleName.nothing
            ? this.$store.dispatch('rolePermission/fetchChildrenRole', { id: this.employeeId })
            : null,

            this.$store.dispatch('leaveManagement/fetchCount', {
                employeeId: this.$route.params.id
            }).then((data) => {
                this.medicalRepData.leaveDaysNumber = data.daysCount
            }),
		]).then((data) => {
            this.myData = []
            this.lineManager = data[0]; 

            this.directBriefEmployee = data[1].map(c => ({ 
                ...c, 
                model: c.lineManager === this.$route.params.id ? c.id : null    
            }))
			// eslint-disable-next-line no-unused-expressions
			this.$route.params.id && !this.medicalReps.length
            ? this.$store.dispatch('medicalreps/fetchAll', { employeeId: this.$route.params.id }).then((data) => {
                this.myData = data[0]          
                this.medicalRepData.name = this.myData?.name;
                this.medicalRepData.birthDate = this.myData.birthDate ? moment(this.myData.birthDate).format('YYYY-MM-DD') : null;
                this.medicalRepData.email = this.myData.email;
                this.medicalRepData.phoneNumber = this.myData.phoneNumber;
                this.medicalRepData.landlineNumber = this.myData.landlineNumber;
                this.medicalRepData.sectorId = this.myData.sectorId;
                this.medicalRepData.address = this.myData.address;
                this.medicalRepData.visitPerDay = this.myData.visitPerDay; 
                this.medicalRepData.jobPosition = this.myData.jobPosition;
                this.medicalRepData.facebookProfileUrl = this.myData.facebookProfileUrl;
                this.medicalRepData.startingDate =
                    this.myData.startingDate ? moment(this.myData.startingDate).format('YYYY-MM-DD') : null;

                this.medicalRepData.username = this.myData.username;
                this.medicalRepData.userType = this.myData.employeeType;
                this.medicalRepData.gender = this.myData.gender;
                if (this.financialTargetValue) {
                    this.$store.dispatch('medicalrepTarget/getTargetFinancialRepById', { id: this.$route.params.id }).then(({ data }) => {
                        this.medicalRepData.financialTargetValue = data.value
                    })
                }
                this.$store.dispatch('medicalrepTarget/fetch', { id: this.$route.params.id }).then((data) => {
                    this.medicalRepData.targetValue = data;
                })
                this.medicalRepImagePath = this.myData.imagePath;
                this.medicalRepData.lineManagerId = this.myData.lineManager
                this.medicalRepData.regionIds = this.myData.regionIds
                this.medicalRepData.specialtyIds = this.myData.specialtyIds
                this.medicalRepData.roleId = this.myData?.roleId
                this.medicalRepData.teamId = this.myData?.teamId
                this.medicalRepData.certificate = this.myData?.certificate
                        
                this.medicalRepData.cityId =
                    this.medicalRepData.regionIds.map(c => c !== undefined ? this.getRegionAllById(c)?.cityId : null)
                    .filter((id, index, arr) => arr.indexOf(id) === index)
            }) : this.myData = this.medicalReps.find(c => c.id === this.$route.params.id)
            
                this.medicalRepData.name = this.myData?.name;
                this.medicalRepData.birthDate = this.myData.birthDate ? moment(this.myData.birthDate).format('YYYY-MM-DD') : null;
                this.medicalRepData.email = this.myData.email;
                this.medicalRepData.phoneNumber = this.myData.phoneNumber;
                this.medicalRepData.landlineNumber = this.myData.landlineNumber;
                this.medicalRepData.sectorId = this.myData.sectorId;
                this.medicalRepData.address = this.myData.address;
                this.medicalRepData.visitPerDay = this.myData.visitPerDay; 
                this.medicalRepData.jobPosition = this.myData.jobPosition;
                this.medicalRepData.facebookProfileUrl = this.myData.facebookProfileUrl;
                this.medicalRepData.startingDate =
                    this.myData.startingDate ? moment(this.myData.startingDate).format('YYYY-MM-DD') : null;

                this.medicalRepData.username = this.myData.username;
                this.medicalRepData.userType = this.myData.employeeType;
                this.medicalRepData.gender = this.myData.gender;
                if (this.financialTargetValue) {
                    this.$store.dispatch('medicalrepTarget/getTargetFinancialRepById', { id: this.$route.params.id }).then(({ data }) => {
                        this.medicalRepData.financialTargetValue = data.value ? data.value : 1
                    })
                }
                this.$store.dispatch('medicalrepTarget/fetch', { id: this.$route.params.id }).then((data) => {
                    this.medicalRepData.targetValue = data;
                })
                this.medicalRepImagePath = this.myData.imagePath;
                this.medicalRepData.lineManagerId = this.myData.lineManager
                this.medicalRepData.regionIds = this.myData.regionIds
                this.medicalRepData.specialtyIds = this.myData.specialtyIds
                this.medicalRepData.roleId = this.myData?.roleId
                this.medicalRepData.teamId = this.myData?.teamId
                this.medicalRepData.certificate = this.myData?.certificate
                        
                this.medicalRepData.cityId =
                    this.medicalRepData.regionIds.map(c => c !== undefined ? this.getRegionAllById(c)?.cityId : null)
                    .filter((id, index, arr) => arr.indexOf(id) === index)
		}).finally(() => {
            this.loading = false
        })
    },

    metaInfo: {
        title: 'Employee info',
        titleTemplate: '%s | Octopharma'
    }
}
</script>
<style scoped>
.form-info {
    position: sticky;
    top: 20px;
}
</style>